import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import COUNTRIES_EN from 'world_countries_lists/data/countries/en/world.json'
import ReactCountryFlag from 'react-country-flag'

const COUNTRIES_EN_OPTIONS = [
    // {
    //     label: 'All countries',
    //     value: 'All countries',
    // },
    ...COUNTRIES_EN.map((o) => {
        return {
            label: (
                <>
                    <ReactCountryFlag
                        countryCode={o.alpha2}
                        svg
                        style={{
                            width: '1em',
                            height: '1em',
                        }}
                        title={o.alpha2}
                    />{' '}
                    {o.name}
                </>
            ),
            value: o.name,
        }
    }),
]

// France first
COUNTRIES_EN_OPTIONS.unshift(
    ...COUNTRIES_EN_OPTIONS.splice(
        COUNTRIES_EN_OPTIONS.findIndex((o) => o.value === 'France'),
        1,
    ),
)

export default function CountryInput({
    value,
    onChange,
    disabled,
    placeholder = 'Country',
    alwaysOpen = false,
    className = '',
    ...rest
}) {
    const [currentCountry, setCurrentCountry] = useState(COUNTRIES_EN_OPTIONS[0])
    const [isEditing, setIsEditing] = useState(false)

    useEffect(() => {
        if (value) setCurrentCountry(value)
    }, [value])

    const HandleCurrentCountryChange = (value) => {
        setCurrentCountry(value)
        onChange(value)
    }

    const HandleBlur = () => {
        setIsEditing(false)
    }

    return (
        <div
            className={className}
            onClick={(event) => {
                if (!disabled) {
                    event.stopPropagation()
                }
            }}
            onDoubleClick={() => {
                if (!disabled) {
                    setIsEditing(true)
                }
            }}
        >
            {isEditing || alwaysOpen ? (
                <Select
                    showSearch
                    value={COUNTRIES_EN_OPTIONS.find((o) => o.value === currentCountry)}
                    onChange={HandleCurrentCountryChange}
                    options={COUNTRIES_EN_OPTIONS}
                    onBlur={HandleBlur}
                    optionFilterProp="children"
                    onSearch={(value) => {
                        console.log(value)
                    }}
                    placeholder={placeholder}
                    filterOption={(input, option) => {
                        return option.value.toLowerCase().includes(input.toLowerCase())
                    }}
                    {...rest}
                />
            ) : (
                <>{(currentCountry ? currentCountry.label : placeholder)}</>
            )}
        </div>
    )
}
